<template>
  <div
    class="checkbox-wrapper"
    :class="params.isAssigned && 'is-assigned'"
    style="display: flex; justify-content: left; top: 7px; position: absolute"
  >
    <!-- :class="disabled && 'checkbox-wrapper--disabled'" -->
    <input
      v-model="value"
      type="checkbox"
      :checked="value"
      @click="click"
      @dblclick="dblClick"
    />
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      value: false
    }
  },
  beforeMount() {
    if (this.params) this.value = this.params.value
  },
  methods: {
    dblClick(event) {
      if (!this.params.isAssigned) {
        event.preventDefault()
      } else {
        this.value = !this.value
        this.params.context.componentParent.changeCheckbox(
          this.params.data,
          this.value
        )
      }
    },
    click(event) {
      if (!(!this.params.isAssigned || this.value)) {
        event.preventDefault()
      } else {
        this.value = !this.value
        this.params.context.componentParent.changeCheckbox(
          this.params.data,
          this.value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox-wrapper {
  width: fit-content;
  display: flex;
  align-items: center; //baseline;
  gap: 0.5rem;
  line-height: 1rem;
  font-size: 1rem;

  &.checkbox-wrapper--disabled {
    cursor: not-allowed;
  }

  input[type='checkbox'] {
    -webkit-appearance: none;
    appearance: none;
    background-color: white;
    margin: 0;

    color: white;
    height: 1rem;
    width: 1rem;
    border: 1px solid #7f8c8d;
    border-radius: 0.15rem;

    // transform: translateY(-0.075em);
    display: grid;
    place-content: center;
  }

  input[type='checkbox']::before {
    content: '';
    width: 16px;
    height: 16px;
    clip-path: polygon(13% 45%, 10% 57%, 30% 90%, 108% 0%, 155% -20%, 43% 82%);
    transform: scale(0);
    // transform-origin: bottom left;
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em #357456; // check color
  }

  input[type='checkbox']:checked {
    background-color: white;
    // border: none;
  }

  input[type='checkbox']:checked::before {
    transform: scale(0.8);
  }

  // input[type="checkbox"]:focus {
  //   outline: max(2px, 0.15em) solid green;
  //   outline-offset: max(2px, 0.15em);
  // }

  input[type='checkbox']:disabled {
    color: #357456;
    cursor: not-allowed;
    opacity: 0.5;
  }

  &.is-assigned {
    input[type='checkbox']::before {
      box-shadow: inset 1em 1em red; // check color
    }
  }
}
</style>
